export default __webpack_public_path__ + "static/media/ranking-page1400.53a31735.jpg";